import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../../core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule, RadioButtonModule } from 'primeng/primeng';
import { TranslateModule } from '@ngx-translate/core';
import { CustomerRequestComponent } from './customer-request.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    RadioButtonModule,
    ReactiveFormsModule,
    TranslateModule,
    NgSelectModule,
    CalendarModule,
    NgxMaskModule.forRoot(),
  ],
  declarations: [CustomerRequestComponent],
})
export class CustomerRequestModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer-request/customer-request.module.ts